<a class="toggle-container" [class.disabled]="disabled" (click)="toggleClick()">
  <div [ngClass]="checked ? 'toggle-bg toggle-on' : 'toggle-bg'">
    <div [@toggleTrigger]="checked ? 'on' : 'off'" class="toggle"></div>
  </div>
</a>
